import { InboxMessage } from '@copilot/common/pages/inbox/ui/types';
import { ReminderStatus } from '@copilot/common/pages/inbox/data/types';

export type CardReminderProps = {
    reminderTimestamp: string;
    reminderType: ReminderStatus;
};

export type InboxV2CardProps = {
    /**
     * Type of card
     */
    cardType: InboxV2CardType;
    /**
     * Inbox message item
     */
    message: InboxMessage;
    /**
     * Callback for viewing the full conversation
     */
    onViewConversation: () => void;
    /**
     * Handler for the remove action
     */
    onRemove: () => Promise<void>;
    /**
     * Reminder associated with the conversation
     */
    reminder?: CardReminderProps;
    /**
     * Should we show thread intent or not
     */
    showIntent?: boolean;
    /**
     * Should we show reply recommendations or not
     */
    isReplyRecommendationsEnabled: boolean;
};

/**
 * Props to inbox header
 */
export type InboxV2CardHeaderProps = {
    contactName: string;
    company: string;
    position: string;
};

// Inbox card type
export const REMINDER_CARD = 'REMINDER';
export const NEW_MESSAGE_CARD = 'NEW_MESSAGE';
export const URGENT_LEAD_CARD = 'URGENT';
export type InboxV2CardType =
    | typeof REMINDER_CARD
    | typeof NEW_MESSAGE_CARD
    | typeof URGENT_LEAD_CARD;
